import { render, staticRenderFns } from "./jdcpaDetail.vue?vue&type=template&id=f2ae2678&scoped=true&"
import script from "./jdcpaDetail.vue?vue&type=script&lang=js&"
export * from "./jdcpaDetail.vue?vue&type=script&lang=js&"
import style0 from "./jdcpaDetail.vue?vue&type=style&index=0&id=f2ae2678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ae2678",
  null
  
)

export default component.exports